module.exports = __webpack_public_path__ + "img/tree-06-h-trunk.fbabaf0d.png";